import "./styles.css";
import { useEffect } from "react";
import React from "react";

const DealsItemGamesByn = ({ item, list }) => {
  useEffect(() => {
    // console.log(item.price);
    // console.log(item.priceSale);
  }, []);

  return (
    <>
      <div
        className={`product-item ${list ? "product-item__list" : " "} ${
          item.price > 99999 ? "product_none" : ""
        }`}
      >
        {list ? (
          ""
        ) : (
          <div className="product-img">
            <img
              className="product-img__image"
              src={`https:${item.logoPicture}?w=162&h=300&q=90&mode=scale`}
            />
          </div>
        )}

        <div className={`product-info ${list ? "product-info__list" : " "}`}>
          <h3>
            <a
              href={`https://www.microsoft.com/ru-ru/p/game/${item.gameId}`}
              target="_blank"
            >
              {item.name}{" "}
            </a>
          </h3>

          {/* Убрал "Товар недоступен для покупки" в display none если выполняется это условие  */}
          <div className="product-price" style={{ marginTop: "10px" }}>
            {item.price > 99999 ? (
              <span className="price">Товар недоступен для покупки</span>
            ) : (
              <>
                <div className="price_account">
                  <span className={`price ${list ? "price__list" : " "}`}>
                    Цена: {Math.ceil(item.priceByn / 1) * 1} BYN{" "}
                  </span>
                </div>

                {/* Пока что нет скидок, чтоб настроить отображение */}
                {/* {item.priceSale < 9999 || item.priceSale === item.price ? (
                  ""
                ) : (
                  <span className={`price ${list ? "price__list" : " "}`}>
                    {Math.ceil(item.priceSale / 10) * 10} рублей{" "}
                    {item.countrySale === "ars" ? (
                      <span style={{ fontSize: 5 }}>I</span>
                    ) : (
                      <span style={{ fontSize: 5 }}>II</span>
                    )}
                  </span>
                )} */}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default DealsItemGamesByn;
